// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */import { DeepfakeState } from './DeepfakeState';
import { NullFilter } from './NullFilter';

export const DeepfakeFilter = {...DeepfakeState,...NullFilter,} as const
export type DeepfakeFilter = typeof DeepfakeFilter[keyof typeof DeepfakeFilter];
